export default "__VITE_ASSET__02638f19__"